import React from 'react';
import { useWebinarSlot } from './useWebinarSlot';
export const WebinarMCStickyBar = ({
  onClickCTA
}: {
  onClickCTA: () => void;
}) => {
  const slot = useWebinarSlot();
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)]" data-id="element-547" data-mp="11o8a057qw882">
      <div className="px-4 pt-2 pb-3 text-center" data-id="element-548" data-mp="xmdc7ap0wcz1">
        <p className="text-sm text-gray-700 mb-2" data-id="element-549" data-mp="xksejc7ewdwy">
          Volgende webinar:{' '}
          <span className="font-bold text-[#1a2b4a]" data-id="element-550" data-mp="9xtyugr49a03">{slot.dateLabel}</span>
          <span className="text-gray-500" data-id="element-551" data-mp="4zaeulw328ad"> ({slot.time} uur)</span>
        </p>
        <button onClick={onClickCTA} className="w-full bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-3 px-6 rounded-full transition-colors text-base shadow-md" data-id="element-552" data-mp="iq5r885sj7ip">
          Inschrijven webinar
        </button>
      </div>
    </div>;
};